<template>

	<drawer
			:title="!!brokerId ? 'Edit broker' : 'Add broker'"
			@updateClose="onClose"
			@updateSave="onSave"
	>
		<div v-if="!!brokerId" class="subTitle">
			Broker controls: ID {{ brokerId }}
		</div>

		<field
				:classError="$v.value.$error"
				margin="5px"
				width="300px"
				label="Broker name"
				placeholder="Enter broker name"
				:setInputValue="value"
				@updateInput="onInput($event, 'value')"
				is-required
		></field>
		<field
				:classError="$v.mc.$error"
				margin="5px"
				width="300px"
				label="MC#"
				placeholder="Enter MC#"
				:setInputValue="mc"
				@updateInput="onInput($event, 'mc')"
				is-required
		></field>
		<field
				margin="5px"
				width="300px"
				label="Mailing address"
				placeholder="Enter mailing address"
				:setInputValue="pa_street_1"
				@updateInput="onInput($event, 'pa_street_1')"
				is-textarea
		></field>
		<field
				:classError="$v.email_address.$error"
				margin="5px"
				width="300px"
				label="Email"
				placeholder="Enter email"
				:setInputValue="email_address"
				@updateInput="onInput($event, 'email_address')"
		></field>
		<field
				margin="5px"
				width="300px"
				label="Phone"
				placeholder="Enter phone"
				:setInputValue="local_phone"
				@updateInput="onInput($event, 'local_phone')"
				is-phone
		></field>
	</drawer>
</template>

<script>
import { mapActions } from "vuex";
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
import Drawer from "@/shared/Drawer/Drawer.vue";

export default {
	name: "BrokersForm",
	components: { Drawer },
	mixins: [ validationMixin ],
	props: {
		broker: Object,
		brokersItem: Object,
		brokerId: Number,
	},
	data: () => ({
		value: '',
		mc: '',
		pa_street_1: '',
		local_phone: '',
		email_address: '',
	}),
	validations: {
		value: { required },
		mc: { required },
		email_address: { email },
	},
	methods: {
		...mapActions([ 'getBrokersItem', 'onBrokersSave', 'setAlert' ]),
		onInput({ value }, key) {
			this[key] = value;
		},
		onClose(isRefresh) {
			this.$emit('updateClose', isRefresh);
		},
		async onSave() {
			this.$v.$touch();
			if (!this.$v.$error) {
				const { value, mc, pa_street_1, local_phone, email_address } = this.$data;
				const values = { value, mc, pa_street_1, local_phone, email_address };

				const { status } = await this.onBrokersSave({ values, id: this.brokerId });
				if (status) {
					this.setAlert({ type: "success", message: "Saving Successfully" });
					this.onClose(1);
				}
			} else {
				await this.setAlert({ type: "error", message: "Saving error" });
			}
		}
	},
	async mounted() {
		if (this.brokerId) {
			await this.getBrokersItem(this.brokerId);
			const { value, mc, pa_street_1, local_phone, email_address } = this.brokersItem;
			this.value = value;
			this.mc = mc;
			this.pa_street_1 = pa_street_1;
			this.local_phone = local_phone;
			this.email_address = email_address;
		}
	}
};
</script>

<style scoped lang="scss">

.subTitle {
	color: var(--base-green);
	font-size: 16px;
	font-weight: 500;
	line-height: 20px;
	letter-spacing: 0.25px;
	margin-bottom: 20px;
}
</style>
